import DashboardLayout from "@/layout/dashboardLayout/DashboardLayout";
import Dashboard from "@/modules/dashboard/views/Dashboard";
import Drivers from "@/modules/dashboard/views/Drivers";
import DashboardRegister from "@/modules/dashboard/views/DashboardRegister";
import DashboardStart from "@/modules/dashboard/views/DashboardStart";
import DashboardFinish from "@/modules/dashboard/views/DashboardFinish";
import Vehicles from "@/modules/dashboard/views/Vehicles";
import Payments from "@/modules/dashboard/views/Payments";
import VehicleCard from "./views/VehicleCard";
import DriverCard from "./views/DriverCard";
import Auth from "../../router/middleware/Auth";

import PageNotFound from "@/components/Dashboard/PageNotFound/PageNotFound";

export default [
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
        meta: { middleware: [Auth] }
      },
      {
        path: "start",
        name: "DashboardStart",
        component: DashboardStart,
        meta: { middleware: [Auth] }
      },
      {
        path: "register",
        name: "DashboardRegister",
        component: DashboardRegister,
        meta: { middleware: [Auth] }
      },
      {
        path: "finish",
        name: "DashboardFinish",
        component: DashboardFinish,
        meta: { middleware: [Auth] }
      },
      {
        path: "drivers",
        name: "Drivers",
        component: Drivers,
        meta: { middleware: [Auth] }
      },
      {
        path: "driver",
        name: "Driver",
        component: DriverCard,
        meta: { middleware: [Auth] }
      },
      {
        path: "vehicles",
        name: "Vehicles",
        component: Vehicles,
        meta: { middleware: [Auth] }
      },
      {
        path: "vehicle",
        name: "Vehicle",
        component: VehicleCard,
        meta: { middleware: [Auth] }
      },
      {
        path: "payments",
        name: "Payments",
        component: Payments,
        meta: { middleware: [Auth] }
      }
    ]
  },
  { path: "*", component: PageNotFound }
];
